import React, { useEffect, useState } from 'react'
import { HiOutlineTrash } from 'react-icons/hi2'
import { useSelector } from 'react-redux'
import ApproveDelete from '../component/form/ApproveDelete'
import DialogDelete from '../component/others/DialogDelete'
import { RootState, TypeDispatch, useAppDispatch } from '../store'
import Alert from '../templates/Alert'
import HeaderUi from '../templates/HeaderUi'
import Table from '../templates/Table'
import { allCanceledPrestasiSantri, dropCanceledPrestasiSantri } from '../store/actions/prestasiSantri'
import { Link } from 'react-router-dom'
import Button from '../component/others/Button'
import EmptyTable from '../templates/EmptyTable'
import TableFields from '../templates/TableFields'

function CanceledPrestasi() {
    const dispatch: TypeDispatch<any> = useAppDispatch()
    const { loadingPrestasiSantri, msgPrestasiSantri, canceledPrestasiAll } = useSelector((state: RootState) => state.prestasiSantri)
    const [showDeletePrestasi, setShowDeletePrestasi] = useState<boolean>(false)
    const [showAlert, setShowAlert] = useState<boolean>(false)
    const [tableHead, setTableHead] = useState(["No", "Nama", "Point", "Ket", "Catatan", "Delete"])
    const [saveOne, setSaveOne] = useState<any>({})
    const hapus = (e: any) => {
        if (e.process === "yes") {
            e.process = true
        }
        else {
            e.process = false
        }
        dispatch(dropCanceledPrestasiSantri(e))
        setShowDeletePrestasi(false)
        setShowAlert(true)
    }
    useEffect(() => {
        if (showAlert) {
            const interval = setInterval(() => {
                setShowAlert(false)
            }, 2000)
            return () => clearInterval(interval)
        }
        else {
            dispatch(allCanceledPrestasiSantri())
        }
    }, [showAlert])
    return (
        <div>
            <Alert show={showAlert} msg={msgPrestasiSantri} />
            <ApproveDelete showForm={showDeletePrestasi} closeForm={setShowDeletePrestasi} data={saveOne} submit={hapus} />
            <HeaderUi title="Laporan Prestasi Terhapus" />
            <Table>
                <Link to={"/home/laporan/point"}>
                    <Button title="Point" />
                </Link>
                <div>
                    {Object.keys(canceledPrestasiAll).length === 0 ?
                        <EmptyTable title="Tidak ada prestasi" />
                        :
                        <TableFields head={tableHead}>
                            {canceledPrestasiAll.map((d: any, id: any) => (
                                <tr className="bg-white border-b hover:bg-gray-100 overflow-y-auto" key={id}>
                                    <td className='px-6 py-3'>{id + 1}</td>
                                    <td className='px-6 py-3'>{d.prestasiSantri?.santri?.nama}</td>
                                    <td className='px-6 py-3'>{d.prestasiSantri?.prestasi?.jumlahPoint}</td>
                                    <td className='px-6 py-3'>{d.prestasiSantri?.prestasi?.judul}</td>
                                    <td className='px-6 py-3'>{d.catatan}</td>
                                    <td className='px-6 py-3'><HiOutlineTrash className='w-6 h-6 cursor-pointer mx-3' onClick={() => {
                                        setSaveOne(d)
                                        setShowDeletePrestasi(true)
                                    }} /></td>
                                </tr>
                            ))}

                        </TableFields>
                    }
                </div>
            </Table>
        </div >
    )
}

export default CanceledPrestasi